const userStatus = {
    NeedSubscription: 0,
    AwaitingPayment: 1,
    Paid: 2,
    Expired: 3
}

export default userStatus